import { render, staticRenderFns } from "./MFormSelectMultiple.vue?vue&type=template&id=2ab422b0&scoped=true&"
import script from "./MFormSelectMultiple.vue?vue&type=script&lang=js&"
export * from "./MFormSelectMultiple.vue?vue&type=script&lang=js&"
import style0 from "./MFormSelectMultiple.vue?vue&type=style&index=0&id=2ab422b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab422b0",
  null
  
)

export default component.exports